<template>
  <div class="multiline-textarea" @focusin="onAnyLineFocus">
    <md-input
      v-for="(line, index) in lineInputValues"
      :id="index === 0 ? inputId : null"
      :key="index"
      v-bind="$attrs"
      :value="line"
      @input="(text) => updateLine(index, text)"
      @keydown.native.enter="focusNextInput"
    />
  </div>
</template>

<script>
import range from 'lodash/range';

export default {
  name: 'multiline-textarea',
  inject: {
    MdField: { default: null },
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    numberOfLines: {
      type: Number,
      required: true,
    },
    inputId: {
      type: String,
      default: null,
    },
  },
  computed: {
    lineInputValues() {
      const lines = this.value.split('\n');
      return range(this.numberOfLines).map(
        (lineIndex) => lines[lineIndex] || ''
      );
    },
  },
  methods: {
    updateLine(indexToUpdate, updatedValue) {
      const updatedLines = this.lineInputValues.map((line, index) =>
        index === indexToUpdate ? updatedValue : line
      );
      this.$emit('input', updatedLines.join('\n').trim());
    },
    onAnyLineFocus(event) {
      if (event.target.tagName === 'INPUT' && this.MdField) {
        this.MdField.value = event.target.value;
      }
      this.$emit('focus', event);
    },
    focusNextInput(event) {
      if (event.target.nextSibling) {
        event.target.nextSibling.focus();
      }
    }
  },
};
</script>

<style scoped>
.multiline-textarea {
  width: 100%;
}

.md-input {
  margin-bottom: 10px;
  width: 100%;
}
.md-input:last-of-type {
  margin-bottom: 0;
}
</style>